import { Injectable } from '@angular/core';
import { Layer } from '../models/layer';
import { CommonSceneLayer } from '../models/common-scene-layer';
import { TeamSceneLayer } from '../models/team-scene-layer';

@Injectable()

export class TeamLayersAdapterService {

  getCommonSceneLayers(companySceneLayers: Layer[], teamSceneLayers: TeamSceneLayer[]): CommonSceneLayer[] {
    return companySceneLayers
      .map(companyLayer => {

        const teamLayer: TeamSceneLayer = teamSceneLayers.find(({ LayerId }: TeamSceneLayer) => LayerId === companyLayer.Id);

        return {
          Id: teamLayer ? teamLayer.LayerId : companyLayer.Id,
          IsDisabledByDefault: teamLayer && companyLayer.IsSupressed,
          isEnabled: !!teamLayer,
          IsVisibleByDefault: teamLayer ? teamLayer.IsVisibleByDefault : false,
          IsDataCollectionEnabled: teamLayer ? teamLayer.IsDataCollectionEnabled : !!teamLayer,
          Slug: companyLayer.Slug,
          Color: companyLayer.LayerColor,
          Name: companyLayer.Name,
          displayName: teamLayer ? teamLayer.Name : companyLayer.Name,
          CreatedAt: companyLayer.CreatedAtUtc,
          order: teamLayer ? teamLayer.order : null
        };
      });
  }

}
